function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js/instance/every";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _Array$isArray from "@babel/runtime-corejs3/core-js/array/is-array";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import React, { Component } from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import { CheckedProvider } from "../Context.js";
var isSet = function isSet(val) {
  if (!val) return false;
  var methods = ['has', 'add', 'delete'];
  return _everyInstanceProperty(methods).call(methods, function (m) {
    return typeof val[m] === 'function';
  });
};
var MultiSelectGroup = /*#__PURE__*/function (_Component) {
  _inherits(MultiSelectGroup, _Component);
  var _super = _createSuper(MultiSelectGroup);
  function MultiSelectGroup() {
    var _this;
    _classCallCheck(this, MultiSelectGroup);
    _this = _super.apply(this, arguments);
    _defineProperty(_assertThisInitialized(_this), "handleValuesChange", function (evt) {
      var value = evt.target.value;
      var _this$props = _this.props,
        values = _this$props.values,
        onValuesChange = _this$props.onValuesChange,
        onChange = _this$props.onChange;
      var newValues;
      if (isSet(values)) {
        newValues = new _Set(values);
        if (values.has(value)) {
          newValues["delete"](value);
        } else {
          newValues.add(value);
        }
      } else if (_Array$isArray(values)) {
        if (_includesInstanceProperty(values).call(values, value)) {
          newValues = _filterInstanceProperty(values).call(values, function (v) {
            return v !== value;
          });
        } else {
          newValues = [].concat(_toConsumableArray(values), [value]);
        }
      } else {
        throw new Error('Expected a Set or an Array object as `values`');
      }
      onChange(evt);
      onValuesChange(newValues, evt);
    });
    return _this;
  }
  _createClass(MultiSelectGroup, [{
    key: "childIsChecked",
    value: function childIsChecked(childProps) {
      var values = this.props.values;
      if (isSet(values)) {
        return values.has(childProps.value);
      }
      if (_Array$isArray(values)) {
        return _includesInstanceProperty(values).call(values, childProps.value);
      }
      throw new Error('Expected a Set or an Array object as `values`');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var children = this.props.children;
      return /*#__PURE__*/React.createElement(CheckedProvider, {
        value: {
          onChange: this.handleValuesChange,
          isChecked: function isChecked(value) {
            return _this2.childIsChecked({
              value: value
            });
          }
        }
      }, children);
    }
  }]);
  return MultiSelectGroup;
}(Component);
_defineProperty(MultiSelectGroup, "defaultProps", {
  onChange: noop,
  onValuesChange: noop
});
process.env.NODE_ENV !== "production" ? MultiSelectGroup.propTypes = {
  /**
   * One to many Checkbox components.
   */
  children: PropTypes.node,
  /**
   * The currently selected values.
   */
  values: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.shape({
    has: PropTypes.func
  })]),
  /**
   * Callback for when user selects a value. Prefer to use `onValuesChange`
   *
   * ```ts
   * type onChange = (evt: React.SyntheticEvent): void
   * ```
   */
  onChange: PropTypes.func,
  /**
   * Callback called when user selects a value. The `values` argument is the new set of values selected. Its type depends on the type given via the `values` prop.
   *
   * ```ts
   * type onValuesChange = (value: Set<string> | string[], evt: React.SyntheticEvent): void
   * ```
   */
  onValuesChange: PropTypes.func
} : void 0;
export default MultiSelectGroup;